let cardDivs = document.querySelectorAll(".tecnology-slider .swiper-wrapper div.card").length;
if(cardDivs <= 4){ document.querySelector(".tecnology-slider .swiper-wrapper").classList.add("center-content"); } 

const tecnologySwiper = new Swiper('.tecnology-slider', {
  // Optional parameters
  slidesPerView: 1,
  spaceBetween: 15, 

  // Navigation arrows
  navigation: {
    nextEl: '.slider-cards__container .swiper-button-next',
    prevEl: '.slider-cards__container .swiper-button-prev',
  },
  breakpoints: {
    769: {
      slidesPerView: 4,
    }
  },
});